<template>
  <div>

    <div style="float:left">
      <h1>{{ title }}</h1>
    </div>
    <div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <table>
          <tr>
            <td> <el-form-item :label="translateWords.ProductName" prop="ProductName"> <el-input
                  v-model="ruleForm.ProductName" :disabled="true"></el-input></el-form-item></td>
          </tr>
          <tr>
            <td> <el-form-item :label="translateWords.ProductCode" prop="ProductCode"> <el-input
                  v-model="ruleForm.ProductCode" :disabled="true"></el-input></el-form-item></td>
          </tr>
          <tr>
            <td> <el-form-item :label="translateWords.SumStorage" prop="SumStorage">
                <el-input :placeholder="translateWords.inputNum" v-model.number="ruleForm.SumStorage"></el-input>
              </el-form-item> </td>
          </tr>
        </table>
        <el-form-item style="float:left">
          <el-button type="primary" @click="submitForm('ruleForm')">{{ translateWords.save }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import AddRack from './AddRack.vue';
import { importScript } from '../util/importScript'

export default {
  components: { AddRack },
  name: 'RK',
  data() {
    return {
      translateWords: {
        ProductName: "产品名称",
        ProductCode: "产品条码",
        SumStorage: "入库数量",
        inputNum: "请输入数字",
        save: "保存",
        countTip: "请选择大于0的数量",
        setSuccess: "设置成功",
        setFail: "设置失败"
      },
      title: '入库操作',
      ruleForm: {
        ProductName: '',
        ProductCode: '',
        SumStorage: '',
      },
      Sys_Guid: '',
      uid: this.$route.query.uid,
      rules: {
        SumStorage: [
          { required: true, message: '请输入入库数量' },
          { type: 'number', message: '层数必须为大于0数字值' }
        ]

      },
    }

  },
  mounted() {
    var that = this;
    importScript(this.baseurl, () => {
      that.translateWord();
    });
  },
  methods: {
    translateWord() {
      var that = this;

      if (window.jsT) {
        this.translateWords = {
          ProductName: window.jsT.T(that.translateWords.ProductName),
          ProductCode: window.jsT.T(that.translateWords.ProductCode),
          SumStorage: window.jsT.T(that.translateWords.SumStorage),
          inputNum: window.jsT.T(that.translateWords.inputNum),
          save: window.jsT.T(that.translateWords.save),
          countTip: window.jsT.T(that.translateWords.countTip),
          setSuccess: window.jsT.T(that.translateWords.setSuccess),
          setFail: window.jsT.T(that.translateWords.setFail)
        };
        console.log(this.translateWords)
        this.title = window.jsT.T(this.title);
        this.ruleForm.rules = {
          SumStorage: [
            { required: true, message: window.jsT.T('请输入入库数量') },
            { type: 'number', message: window.jsT.T('层数必须为大于0数字值') }
          ]

        };
      }
      else {
        console.log("翻译组件加载失败")
      }
    },
    initform(rowjson) {
      this.ruleForm.ProductName = rowjson.ProductName;
      this.ruleForm.ProductCode = rowjson.ProductCode;
      this.Sys_Guid = rowjson.Sys_Guid;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          if (this.ruleForm.SumStorage <= 0) {
            alert(this.translateWords.countTip);
            return;
          }

          var that = this;
          let fd = new FormData();
          fd.append("Sys_Guid", this.Sys_Guid);
          fd.append("SumStorage", this.ruleForm.SumStorage);
          fd.append("cmd", "SaveRK");
          fd.append("uid", this.uid);
          this.$http.post(this.actionurl, fd)
            .then(res => {
              if (res.data.Message == "") {
                //  this.$message({
                //   message: '设置成功',
                //   type: 'success'
                // });    
                alert(that.translateWords.setSuccess);
                this.resetForm(formName);
                this.$emit("closedialogrk");
                this.$emit('reload');
              }
              else {
                alert(that.translateWords.setFail + res.data.Message);
                // this.$message({
                //   message: res.data.Message,
                //   type: "error"
                // });
              }
            })
        } else {
          return false;
        }
      });
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/RK.vue